import { render, staticRenderFns } from "./ProjectTechnicalReview.vue?vue&type=template&id=ab7f80ce&scoped=true"
import script from "./ProjectTechnicalReview.vue?vue&type=script&lang=js"
export * from "./ProjectTechnicalReview.vue?vue&type=script&lang=js"
import style0 from "./ProjectTechnicalReview.vue?vue&type=style&index=0&id=ab7f80ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab7f80ce",
  null
  
)

export default component.exports